import { lazy } from 'react'

const BasicDemo = lazy(() => import('./components/BasicDemo'))
const EnvironmentBlurAndTransitions = lazy(() =>
  import('./components/EnvironmentBlurAndTransitions')
)
const ParingThreeToUI = lazy(() => import('./components/ParingThreeToUI'))
const LoadDragon = lazy(() => import('./components/LoadDragon'))
const Poimandres = lazy(() => import('./components/Poimandres'))
const PoimandresFBX = lazy(() => import('./components/PoimandresFBX'))
const RaycastVehicle = lazy(() => import('./components/RaycastVehicle'))
const UseIntersectAndScrollControls = lazy(() =>
  import('./components/UseIntersectAndScrollControls')
)
const HorizontalTiles = lazy(() => import('./components/HorizontalTiles'))
const InteriorTour = lazy(() => import('./components/InteriorTour'))
const InteriorTour2 = lazy(() => import('./components/InteriorTour2'))

const Files = [
  {
    path: '/',
    component: BasicDemo
  },
  {
    path: '/environment-blur-and-transitions',
    component: EnvironmentBlurAndTransitions
  },
  {
    path: '/paring-three-to-ui',
    component: ParingThreeToUI
  },
  {
    path: '/load-dragon',
    component: LoadDragon
  },
  {
    path: '/poimandres',
    component: Poimandres
  },
  {
    path: '/poimandresFBX',
    component: PoimandresFBX
  },
  {
    path: '/raycast-vehicle',
    component: RaycastVehicle
  },
  {
    path: '/use-intersect-and-scroll-controls',
    component: UseIntersectAndScrollControls
  },
  {
    path: '/horizontal-tiles',
    component: HorizontalTiles
  },
  {
    path: '/interior-tour',
    component: InteriorTour
  },
  {
    path: '/interior-tour-2',
    component: InteriorTour2
  }
]

export default Files
